import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SystemLockService } from './system-lock.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(private _systemLockService: SystemLockService) {}

  get countryCode(){
    return localStorage.getItem("country")
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req.clone();
    if (
      req.url.indexOf('.php') === -1 &&
      (req.headers.get('Authorization') == null ||
        req.headers.get('Authorization') == undefined)
    ) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'accept-language': localStorage.getItem("accept-language") || 'en-US',
          'country-code': this.countryCode || 'MY',
        },
      });
    } else {
      authReq = req.clone({
        setHeaders: {
          'accept-language': localStorage.getItem("accept-language") || 'en-US',
          ...(req.url.indexOf(environment.rockset_lambda_url) === -1 && {'country-code': this.countryCode || 'MY'}),
        },
      });
    }

    if (this._systemLockService.isSystemLocked() && !this._systemLockService.isWhitelistedUrl(req.url)) {
      this._systemLockService.showLockModal();
      return throwError(() => new HttpErrorResponse({ status: 423, statusText: 'System Locked' }));
    }

    return next.handle(authReq).pipe(
      map((resp) => {
        if (resp instanceof HttpResponse) {
          return resp.clone();
        }
      })
    );
  }
}
